export const PALETTE = [
    // '#ef4444', '#f97316', '#f59e0b', '#22c55e', '#14b8a6',
    '#3b82f6', '#6172f8', '#a855f7', '#ec4899', '#f43f5e',
];

function djb2(str) {
    let h = 5381;
    for (let i = 0; i < str.length; i++) {
        h = ((h << 5) + h + str.charCodeAt(i)) >>> 0;
    }
    return h;
}

export function colorForUserId(id) {
    return PALETTE[djb2(String(id)) % PALETTE.length];
}
